export default __webpack_public_path__ + "static/homepage-start-b56694654f5e09152f45d6a2f9cc33dc.jpg";